export const MessageBlock = ({ icon: Icon, message }) => {
  return (
    <div className='bg-perception-black-800 text-perception-gray-200 w-full text-md flex flex-col items-center justify-center h-full'>
      <Icon className='w-8 h-8' />
      <span className='mt-2'>{message}</span>
    </div>
  );
};
